import React, { useRef, useState, useEffect, createRef } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/navigation.css';

const items = [
  {
    name: 'Book',
    color: '#f44336',
    href: '/client/find-route',
  },
  {
    name: 'Track',
    color: '#e91e63',
    href: '/client/track',
  },
  {
    name: 'History',
    color: '#9c27b0',
    href: '/client/history',
  },
  {
    name: 'About',
    color: '#673ab7',
    href: '/client/about',
  },
  {
    name: 'Help',
    color: '#3f51b5',
    href: '#',
  },
];

const Menu = ({ items }) => {
  const $root = useRef();
  const $indicator1 = useRef();
  const $indicator2 = useRef();
  const $items = useRef(items.map(createRef));
  const [active, setActive] = useState(0);

  const animate = () => {
    const menuOffset = $root.current.getBoundingClientRect();
    const activeItem = $items.current[active].current;
    const { width, height, top, left } = activeItem.getBoundingClientRect();

    const settings = {
      x: left - menuOffset.x,
      y: top - menuOffset.y,
      width: width,
      height: height,
      backgroundColor: items[active].color,
      ease: 'elastic.out(.7, .7)',
      duration: 0.8,
    };

    // gsap.to($indicator1.current, {
    //   ...settings,
    // })

    // gsap.to($indicator2.current, {
    //   ...settings,
    //   duration: 1
    // })
  };
  useEffect(() => {
    animate();
    window.addEventListener('resize', animate);

    return () => {
      window.removeEventListener('resize', animate);
    };
  }, [active]);

  return (
    <div ref={$root} className='menu'>
      {items.map((item, index) => (
        <Link
          key={item.name}
          ref={$items.current[index]}
          style={{ color: item.color, textDecoration: 'none' }}
          className={`item ${active === index ? 'active' : ''}`}
          onMouseEnter={() => {
            setActive(index);
          }}
          to={item.href}
        >
          {item.name}
        </Link>
      ))}
      <div ref={$indicator1} className='indicator' />
      <div ref={$indicator2} className='indicator' />
    </div>
  );
};

function Navigation() {
  return (
    <div style={{ background: '' }}>
      <Menu items={items} />
    </div>
  );
}

export default Navigation;
